import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

/**
 * App-wide loading state shown while lazy-loaded routes are fetched.
 * 
 * Instead of a spinner, we render a simple skeleton layout that roughly
 * matches the homepage: a hero section and a few content cards.
 */
const LoadingSpinner: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        display: 'flex',
        alignItems: 'stretch',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          py: { xs: 6, sm: 8 },
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 6, sm: 8 },
        }}
      >
        {/* Hero skeleton */}
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Skeleton variant="text" width="70%" height={48} />
              <Skeleton variant="text" width="90%" height={32} />
              <Skeleton variant="text" width="80%" height={32} />
              <Box sx={{ mt: 2 }}>
                <Skeleton variant="rounded" width={160} height={44} />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton
              variant="rounded"
              sx={{
                width: '100%',
                height: { xs: 220, sm: 280, md: 320 },
                borderRadius: 3,
              }}
            />
          </Grid>
        </Grid>

        {/* Card row skeleton */}
        <Grid container spacing={3}>
          {[0, 1, 2].map((key) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Skeleton variant="rounded" width="40%" height={20} />
                <Skeleton variant="text" width="90%" height={24} />
                <Skeleton variant="text" width="95%" height={24} />
                <Skeleton variant="text" width="80%" height={24} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default LoadingSpinner;







